import React from 'react';
import { Icon } from '@youngcapital/component-library';
import PropTypes from 'prop-types';
import {
  ACTIVE_KEY,
  COMPLETE_KEY,
  PENDING_KEY
} from '../ProgressCard/constants';

const progressClasses = {
  [COMPLETE_KEY]: { colorState: '--success', textState: '' },
  [ACTIVE_KEY]: { colorState: '', textState: 'text--bold' },
  [PENDING_KEY]: { colorState: '--unfinished', textState: 'text--grey' }
};

const ProgressCardItem = ({ state, isLastStep, label }) => {
  const style = progressClasses[state];
  return (
    <li className='list__item'>
      <div className={`list__track list__track${style.colorState}`}>
        <Icon variant='check' className='list__icon' />
        {!isLastStep && <hr className='line line__progress' />}
      </div>
      <div className='list__description list__description-state'>
        <p className={style.textState}>{label}</p>
      </div>
    </li>
  );
};

ProgressCardItem.propTypes = {
  isLastStep: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired,
  state: PropTypes.string.isRequired
};

export default ProgressCardItem;
